import nanobus from "nanobus"

// Singleton event 🚌

export default new nanobus()
